import { render } from "./FooterSection.vue?vue&type=template&id=2557086c&scoped=true&ts=true"
import script from "./FooterSection.vue?vue&type=script&lang=ts"
export * from "./FooterSection.vue?vue&type=script&lang=ts"

import "./FooterSection.vue?vue&type=style&index=0&id=2557086c&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2557086c"],['__file',"src/components/FooterSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2557086c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2557086c', __exports__)) {
    console.log('reload')
    api.reload('2557086c', __exports__)
  }
  
  module.hot.accept("./FooterSection.vue?vue&type=template&id=2557086c&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('2557086c', render)
  })

}


export default __exports__